import React from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";

export default function CanvasStep1(props) {
  const {
    dataStep1,
    setDataStep1,
    selectorSBU,
    fetchSelectorUnit,
    selectorUnit,
    loadingUnit,
    openCanvas,
    setOpenCanvas,
    fetchJadwalDokter,
    setLoadingLoad,
    setDataStep2,
    initStep2,
    setUnitJenis3,
  } = props;

  let hariIni = moment().format("YYYY-MM-DD");
  let maxHari =
    dataStep1?.sbu === "RSPG" && dataStep1.unit !== "P37"
      ? moment().add(30, "days").format("YYYY-MM-DD")
      : dataStep1?.sbu === "RSPG" && dataStep1.unit === "P37"
      ? moment().add(5, "days").format("YYYY-MM-DD")
      : moment().add(3, "days").format("YYYY-MM-DD");

  let hari_bpjs =
    dataStep1?.sbu === "RSPG"
      ? moment().add(2, "days").format("YYYY-MM-DD")
      : moment().add(3, "days").format("YYYY-MM-DD");

  return (
    <Offcanvas
      show={openCanvas}
      onHide={() => setOpenCanvas(false)}
      key="filter"
      placement="bottom"
      name="filter"
      style={{ zIndex: 99999, minHeight: "65%" }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Ubah Tujuan dan Tanggal</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Rumah Sakit / Klinik Tujuan</Form.Label>
            <Select
              styles={{
                color: "black",
              }}
              id="sbu"
              name="sbu"
              options={selectorSBU}
              value={selectorSBU.find((find) => find?.value === dataStep1?.sbu)}
              onChange={(e) => {
                fetchSelectorUnit(e.value);
                setDataStep1({
                  ...dataStep1,
                  sbu: e.value,
                  sbuname: e.label,
                  unit: null,
                  unitname: null,
                });
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Unit Rawat Jalan Tujuan</Form.Label>
            {dataStep1?.sbu !== null ? (
              <Select
                styles={{
                  color: "black",
                }}
                id="unit"
                name="unit"
                options={selectorUnit}
                isLoading={loadingUnit}
                value={selectorUnit.find(
                  (find) => find?.value === dataStep1?.unit
                )}
                onChange={(e) => {
                  setDataStep1({
                    ...dataStep1,
                    unit: e.value,
                    unitname: e.label,
                  });
                  setUnitJenis3(e.jenis3);
                }}
              />
            ) : (
              <Form.Control
                type="text"
                value="Pilih Rumah Sakit / Klinik Tujuan Terlebih Dahulu..."
                disabled
              />
            )}
          </Form.Group>

          {dataStep1?.sbu === "RSPG" ? (
            <>
              {" "}
              <Form.Group className="mb-3">
                <Form.Label>Tanggal</Form.Label>
                <Form.Control
                  type="date"
                  id="tanggal"
                  name="tanggal"
                  disabled={dataStep1?.sbu === null || dataStep1?.unit === null}
                  value={dataStep1?.date}
                  onChange={(e) =>
                    setDataStep1({ ...dataStep1, date: e.target.value })
                  }
                  min={moment().add(0, "days").format("YYYY-MM-DD")}
                  max={
                    dataStep1?.sbu === "RSPG" && dataStep1.unit !== "P37"
                      ? moment().add(30, "days").format("YYYY-MM-DD")
                      : dataStep1?.sbu === "RSPG" && dataStep1.unit === "P37"
                      ? moment().add(5, "days").format("YYYY-MM-DD")
                      : moment().add(3, "days").format("YYYY-MM-DD")
                  }
                  // disabled={true}
                />
              </Form.Group>
            </>
          ) : (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Tanggal</Form.Label>
                <Form.Control
                  type="date"
                  id="tanggal"
                  name="tanggal"
                  disabled={dataStep1?.sbu === null || dataStep1?.unit === null}
                  value={dataStep1?.date}
                  onChange={(e) =>
                    setDataStep1({ ...dataStep1, date: e.target.value })
                  }
                  min={moment().add(0, "days").format("YYYY-MM-DD")}
                  max={moment().add(3, "days").format("YYYY-MM-DD")}
                  // disabled={true}
                />
              </Form.Group>
            </>
          )}
          <br />
          <div className="d-grid gap-2">
            <Button
              variant="warning"
              disabled={
                dataStep1?.sbu === null ||
                dataStep1?.unit === null ||
                dataStep1?.date === null ||
                moment(dataStep1.date).isValid() === false
              }
              onClick={() => {
                setDataStep2(initStep2);
                setOpenCanvas(false);
                setLoadingLoad(true);
                fetchJadwalDokter();
              }}
            >
              Simpan
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
